<template>
  <div>
    <Loading v-if="showWait" />
    <div v-else>
      <PageTitle
        :main="$t('plano-de-safra') + `${ this.plan == 'BD' ? 'BUDGET' : '' } ${this.unit ? ' - '+this.unit: ''}`"
        sub=""
        imagem="Planejamento.png"
      />
      <GridPlan :plan="plan" @unit="alterUnit=$event"></GridPlan>
    </div>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import GridPlan from "../template/GridPlan";
import Loading from "@/components/template/Loading.vue"
import {mapState} from "vuex";

export default {
  name: "ProductionPlan",
  components: { GridPlan, PageTitle, Loading },
  computed: mapState(["showWait"]),
  data() {
    return {
      plan: this.$route.params.unit,
      unit: "",
      imagem: "",
      alterUnit: ""
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.plan = to.params.unit;
      // console.log("to: " + this.plan);
    },
    alterUnit(u){
      this.unit = u
    }
  },
  beforeCreate(){
    this.$store.commit("setShowWait", true);
  },
  mounted(){
    this.$store.commit("setShowWait", false);
  }
};
</script>

<style scoped>
img {
  max-height: 45px;
}
</style>
